import { createRoot } from 'react-dom/client'
import { Chart as ChartJS } from 'chart.js'
import './index.css'

ChartJS.defaults.font.family = '"NoirPro", sans-serif';

import App from './App.jsx'

createRoot(document.getElementById('root')).render(
    <App />
)
